import CTL_LoadingScreen from '@/compo/CTL_LoadingScreen';
import DefaultLayout from '@/layout/default';

export default [
  {
    path: '/',
    HydrateFallback: () => <CTL_LoadingScreen/>,
    errorElement: <div>Error Page</div>,
    element:<DefaultLayout />,
    children:[
      {
        index:true,
        lazy: async ()=>{
          //await delay(1000)
          const compo = await import('./Landing');
          return{ Component:compo.default }
        },
        
      },
    ]
    //lazy: ()=>import('./index'),
    // Component: async()=>{
    //   return await import('./index');
    // }

    
  },
  
]


